import { twMerge } from "tailwind-merge";

import Icons from "assets";
import { IconButton } from "ui/icon-button";
import {
  SidebarMenu,
  type SidebarMenuItem,
  type SidebarMenuSection,
} from "components/partials/sidebar-menu";

export type SchemaSidebarProps = {
  isCollapsed: boolean;
  onCollapsedChange: (collapsed: boolean) => void;
  sections: SidebarMenuSection[];
  activeItemId?: string;
  onItemSelect: (item: SidebarMenuItem) => void;
  className?: string;
};

export const SchemaSidebar = ({
  isCollapsed,
  onCollapsedChange,
  sections,
  activeItemId,
  onItemSelect,
  className,
}: SchemaSidebarProps) => (
  <SidebarMenu
    isCollapsed={isCollapsed}
    itemLabelSize="sm"
    className={twMerge("shrink-0", className)}>
    <div className={twMerge("pt-4 pb-1", isCollapsed ? "flex justify-center px-3" : "px-4")}>
      <IconButton
        color="inherit"
        variant="text"
        size="medium"
        aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        onClick={() => onCollapsedChange(!isCollapsed)}>
        <Icons.Sidebar />
      </IconButton>
    </div>
    {!isCollapsed && (
      <SidebarMenu.Items
        sections={sections}
        activeItemId={activeItemId}
        onItemSelect={onItemSelect}
        className="py-3"
      />
    )}
  </SidebarMenu>
);
